import { ref } from 'vue'

import {
  requestCreateTweet,
  requestDeleteTweet,
} from '@/api/feeds'

export default function useTweetData() {
  const tweetData = {
    isCreating: ref(false),
    hasCreatingError: ref(false),
  }

  const createTweet = ({ stockId, content }) => {
    tweetData.isCreating.value = true
    tweetData.hasCreatingError.value = false

    return requestCreateTweet({
      content,
      stockId,
    })
      .then((response) => {
        if (response.data.error) { tweetData.hasCreatingError.value = true }
        return response
      })
      .catch((error) => {
        tweetData.hasCreatingError.value = true
        throw error
      })
      .finally(() => {
        tweetData.isCreating.value = false
      })
  }

  const deleteTweet = ({ feedableId }) => requestDeleteTweet({
    id: feedableId,
  })

  const resetTweetData = () => {
    tweetData.isCreating.value = false
    tweetData.hasCreatingError.value = false
  }

  return {
    tweetData,
    createTweet,
    deleteTweet,
    resetTweetData,
  }
}
